var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherWindIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "g79r662sqa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.725490 0 0 0 0 0.737255 0 0 0 0 0.745098 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#g79r662sqa)",
    transform: "translate(-1309 -137) translate(1298 127)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#E36510",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.889 33.778h17.946c4.572 0 11.319-1.817 10.714-8.957-.64-7.548-8.7-7.42-10.235-3.198-.96 2.636.256 4.861 2.424 4.99",
    transform: "translate(11 10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.889 40.889h35.724c4.572 0 11.318-1.817 10.714-8.957-.64-7.548-8.7-7.42-10.236-3.198-.959 2.637.256 4.861 2.424 4.99M16.889 47.176h17.946c4.572 0 11.319 1.817 10.714 8.957-.64 7.548-8.7 7.42-10.235 3.198-.96-2.637.256-4.862 2.424-4.99",
    transform: "translate(11 10)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherWindIcon);
export default __webpack_public_path__ + "static/media/weather-wind-icon.2eccfcff8f45044019113dfcaf8abce7.svg";
export { ForwardRef as ReactComponent };